import templateUrl from './company-status-inquiry-reports.component.html'

export const CompanyStatusInquiryReportsComponent = {
    controller: CompanyStatusInquiryReportsController,
    controllerAs: "vm",
    templateUrl
};

function CompanyStatusInquiryReportsController(icdCorporationReportService, utilityService, apexApiUrl) {
    'ngInject';
    const vm = this;

    vm.reports;
    vm.filters = {};
    vm.showFilters = true;

    vm.filterReport = filterReport;
    vm.exportXlsx = exportXlsx;
    vm.$onInit = $onInit;

    return;

    function $onInit() {
        utilityService.showLoading();
        icdCorporationReportService.retrieveCompanyStatusInquiryReports()
            .then(function (reports) {
                vm.reports = reports.sort(sortReport);
                vm.totals = reports.reduce(aggregateReportTotals, {});
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.loaded = true;
                utilityService.hideLoading();
            });
    }

    function filterReport(report) {
        return !vm.filters.CountryID || report.StateProvince.CountryID === vm.filters.CountryID;
    }

    function sortReport(a, b) {
        return a.Owner < b.Owner ? -1 : 1;
    }

    function exportXlsx() {
        window.location.href = apexApiUrl + "icd-corporations/inquiry.xlsx";
    }

    function aggregateReportTotals(totals, report) {
        totals.NumberOfActiveEmployees = (totals.NumberOfActiveEmployees || 0) + report.NumberOfActiveEmployees;
        totals.NumberOfTerminatedEmployees = (totals.NumberOfTerminatedEmployees || 0)
            + report.NumberOfTerminatedEmployees;

        return totals;
    }
}
